import { render, staticRenderFns } from "./SummaryTreatmentModal.vue?vue&type=template&id=62556dfa&scoped=true"
import script from "./SummaryTreatmentModal.vue?vue&type=script&lang=js"
export * from "./SummaryTreatmentModal.vue?vue&type=script&lang=js"
import style0 from "./SummaryTreatmentModal.vue?vue&type=style&index=0&id=62556dfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62556dfa",
  null
  
)

export default component.exports